import batch from 'function-batch';
import { Logger } from './logger';
import { HISTORY, STATE_UPDATE } from './webSocketMiddleware.constants';

export const WebSocketTypes = {
    TURBINE: 'TURBINE',
    GRID_CONNECTION: 'GRID_CONNECTION',
    POWER_PLANT: 'POWER_PLANT',
    WEATHER: 'WEATHER',
    HISTORICAL_PRODUCTION_FORECAST: 'HISTORICAL_PRODUCTION_FORECAST',
    ALARM: 'ALARM',
    ROP: 'ROP',
    VISITOR_LOG: 'VISITOR_LOG',
    PERSON: 'PERSON',
    WORK_ORDER: 'WORK_ORDER',
    PRODUCTION_FORECAST: 'PRODUCTION_FORECAST',
    POWER_PRICE: 'POWER_PRICE',
    PERF_METRICS: 'PERF_METRICS',
    WEATHER_FORECAST: 'WEATHER_FORECAST',
    FEED_STATUS: 'FEED_STATUS',
    TRANSFER_LIST: 'TRANSFER_LIST',
    VESSEL: 'VESSEL',
    LIGHTNING_ALERT: 'LIGHTNING_ALERT',
};

const actions = {
    [WebSocketTypes.TURBINE]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'parksData/loadMultipleTurbines', payload })),
        // historyAction: 'turbines/updateOneHistory',
        //  platformAction: 'offshorePlatforms/updateOne',
    },
    [WebSocketTypes.GRID_CONNECTION]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'parksData/loadMultiplePowerGrids', payload })),
        // historyAction: 'powerGrids/loadOneHistory',
    },
    /*  
    [WebSocketCommands.POWER_PLANT]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'plantData/loadMultiple', payload })),
        historyAction: 'plantData/loadHistory',
    },
      */
    [WebSocketTypes.WEATHER]: {
        action: 'parksData/loadWeather',
        //  historyAction: 'parksData/loadWeatherHistory',
    },

    [WebSocketTypes.HISTORICAL_PRODUCTION_FORECAST]: {
        action: 'parksData/loadForecastHistory',
        historyAction: 'parksData/loadForecastHistory',
    },
    /*
    [WebSocketCommands.ALARM]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'logTabs/loadMultipleAlarms', payload })),
    },
    [WebSocketCommands.ROP]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'logTabs/loadMultipleLogs', payload })),
    },
    [WebSocketCommands.VISITOR_LOG]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'logTabs/loadMultipleLogs', payload })),
    },
    [WebSocketCommands.PERSON]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'logTabs/loadMultipleVisitors', payload })),
    },
    [WebSocketCommands.WORK_ORDER]: {
        batchAction: batch((payload, dispatch) => dispatch({ type: 'logTabs/loadMultipleWorkOrders', payload })),
    },

    [WebSocketCommands.PRODUCTION_FORECAST]: { action: 'powerGrids/loadForecast' },
      */
    [WebSocketTypes.POWER_PRICE]: { action: 'parksData/loadPlantData' },
    [WebSocketTypes.TRANSFER_LIST]: { action: 'parksData/loadTransferData' },
    [WebSocketTypes.VESSEL]: { action: 'parksData/loadVesselData' },
    /*
    PERF_METRICS: { action: 'plantData/addPerformanceMetrics' },
      */
    [WebSocketTypes.WEATHER_FORECAST]: { action: 'parksData/loadForecast' },

    [WebSocketTypes.FEED_STATUS]: { action: 'parksData/loadSystemStatus' },
    [WebSocketTypes.LIGHTNING_ALERT]: { action: 'parksData/loadLightningAlert' },
};

/* eslint-disable consistent-return, camelcase  */

export const rematchActionDispatcher = (dispatch, data, parkName) => {
    const { command, entityKey, entityType, last_update_time, fields } = data;

    if (!entityKey || !entityType || !actions[entityType]) {
        /* Backend will soon filter out entities we don't need. */
        Logger.log(
            'Following entity from WebSocket not recognized:',
            entityKey,
            entityType,
            actions[entityType],
            typeof data,
            data
        );
        return;
    }

    switch (command) {
        case HISTORY: {
            if (actions[entityType].historyAction) {
                dispatch({
                    type: actions[entityType].historyAction,
                    payload: { parkName, ...data },
                });
            } else {
                Logger.debug(`No historyAction for ${entityKey}`);
            }

            break;
        }

        case STATE_UPDATE: {
            const payload = {
                entityKey,
                entityType,
                last_update_time,
                parkName,
                ...fields,
            };

            if (actions[entityType].batchAction) {
                actions[entityType].batchAction(payload, dispatch);
            } else {
                const isPlatform = /^OSP.?$/.test(entityKey);

                if (isPlatform) {
                    console.warn('isPlatform.....', isPlatform, entityKey);
                    break;
                }

                dispatch({
                    type: actions[entityType].action,
                    payload,
                });
            }
            break;
        }
        default:
            Logger.error('Unknown message received', data);
    }
};
